export default __webpack_public_path__ + "static/media/public.e53aae9f.svg";